import * as React from 'react';
import { connect } from 'react-redux';
import ScrollContainer from 'react-indiana-drag-scroll';
import {updateGloop} from "../../../actions/update";
import {userCanShare} from "../../../functions";

export class CustomizeControleComponent extends React.Component {
	state = {};

	getImages = () => {
		const {ui,options, gloop = {}} = this.props;
		const {data = {}} = options;
		let images =[]
		for(let key in data){
			if(key.indexOf('layer_1_option') !== -1 && data[key]){
				images.push(data[key])
			}
		}
		return images;
	}


	render() {
		const {ui,options, gloop = {}} = this.props;
		const {data = {}} = gloop;
		if(!options || !gloop){
			return '';
		}

		const images = this.getImages();
		const image = data.selected_visual_object ? data.selected_visual_object : 0;
		return (
			<ScrollContainer className="scroll-container">
				<div className={'gloop-customize-controls'}>
					<div className={'gloop-images-controls'}>
						<ul>
							{images.map( ( item , index ) => {
								return (<li className={image == index ? 'active' : ''}>
									<a
										className={ (!window.UserId && index >= 2 || !userCanShare() && index >= 2) ? 'disabled' : ''}
										href={'#'}
										onClick={(e) => {
											e.preventDefault();
											if((!window.UserId && index >= 2) || (!userCanShare() && index >= 2) ){
												let popup = document.querySelector('.upgrade-info');
												popup.style.display = 'inline-block';
												setTimeout(function () {
													popup.style.display = 'none';
												}, 4000);
												return null;
											}
											updateGloop({
												selected_visual_object : index
											},true,{
													screen_name : 'visual_object',
													button_id : index
											});
										}}
									>
										<img src={item} alt={''} />
									</a>
								</li>);
							})}
						</ul>
					</div>
				</div>
				</ScrollContainer>
		)
	}
}

const mapStateToProps = (state) => {
	const gloop = state.gloops[state.activeGloop];
	let options = null;
	if(gloop && gloop.data){
		options = state.gloopsOptions[gloop.data.original_gloop[0]]
	}
	return {
		ui: state.ui,
		gloop : gloop,
		options : options
	};
}
const CustomizeControle = connect(mapStateToProps)(CustomizeControleComponent)
export default CustomizeControle;
